module.exports = __webpack_public_path__ + "img/LTU.7bc7ef61.png";